import domReady from '../helpers/dom-ready';

domReady(() => {
  const scrollIndicator = document.querySelector('.scroll-indicator');
  const blockContainer = document.querySelector('main');

  if (scrollIndicator) {
    scrollIndicator.addEventListener('click', () => {
      const firstBrixBlock = blockContainer.querySelector('.brix-block');

      window.scrollTo({
        top: firstBrixBlock.getBoundingClientRect().height,
        left: 0,
        behavior: 'smooth',
      });
    });

    setTimeout(() => {
      scrollIndicator.classList.remove('-hide');
    }, 3300);

    window.addEventListener('scroll', () => {
      if (window.pageYOffset < 10 && scrollIndicator.classList.contains('-hide')) {
        scrollIndicator.classList.remove('-hide');
      } else if (window.pageYOffset >= 10 && !scrollIndicator.classList.contains('-hide')) {
        scrollIndicator.classList.add('-hide');
      }
    });
  }
});
